import { motion } from 'framer-motion';
import { useLang } from '../context/LangContext';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { staggerContainer, staggerChild } from '../animations/variants';

const sections = [
  { titleKey: "privacy.intro.title", textKey: "privacy.intro.text" },
  { titleKey: "privacy.data.title", textKey: "privacy.data.text" },
  { titleKey: "privacy.purpose.title", textKey: "privacy.purpose.text" },
  { titleKey: "privacy.storage.title", textKey: "privacy.storage.text" },
  { titleKey: "privacy.rights.title", textKey: "privacy.rights.text" },
  { titleKey: "privacy.cookies.title", textKey: "privacy.cookies.text" },
];

export default function ConfidentialitePage() {
  const { t } = useLang();

  return (
    <div data-testid="confidentialite-page" className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.h1
            className="font-bold tracking-tight text-white mb-12"
            style={{ fontSize: 'clamp(36px, 5vw, 56px)' }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {t("privacy.title")}
          </motion.h1>

          <motion.div
            className="space-y-10"
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
          >
            {sections.map((section, i) => (
              <motion.div key={i} variants={staggerChild}>
                <h2 className="text-xl font-semibold text-white mb-3">{t(section.titleKey)}</h2>
                <div className="text-sm text-neutral-400 leading-relaxed whitespace-pre-line">
                  {t(section.textKey)}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
